import React from 'react'
import styles from './styles.module.css'
import range from 'lodash/range'
import autobind from 'autobind-decorator'
import withMutation from '@packages/react-apollo-decorators/lib/withMutation'
import gql from 'graphql-tag'
import withMessage from '@packages/justo-parts/lib/decorators/withMessage'
import isString from 'lodash/isString'
import {sendPosthogData, EVENTS} from '@helpers/posthog'
import get from 'lodash/get'

const MAX_SELECT_AMOUNT = 20
const MORE_SELECT_AMOUNT = MAX_SELECT_AMOUNT + 1
export interface AmountProps {
  showMessage?: Function
  item: any
  updateCartItemAmount?: Function
  readOnly: boolean
  amountClassname: string
}

@withMutation(gql`
  mutation updateCartItemAmount($cartItemId: ID, $amount: Float) {
    updateCartItemAmount(cartItemId: $cartItemId, amount: $amount) {
      _id
      amount
    }
  }
`)
@withMessage
export default class Amount extends React.Component<AmountProps> {
  state = {
    inputState: undefined
  }

  @autobind
  async update(amount) {
    try {
      await this.props.updateCartItemAmount(
        {cartItemId: this.props.item._id, amount},
        {refetchQueries: ['getMyCart', 'getMyOrderPreferences', 'getCheckout']}
      )
    } catch (error) {
      this.props.showMessage(error)
    }
  }

  @autobind
  onChange(event) {
    const amount = Number(event.target.value)
    if (amount === 0) {
      sendPosthogData(EVENTS.product.setQuantityTo0, {
        ...this.props.item,
        ...this.props.item.product
      })
    }
    this.update(amount)
    this.setState({inputState: String(amount)})
  }

  renderOptions() {
    const maxPurchaseQuantity = get(this.props, 'item.product.maxPurchaseQuantity')
    const rangeMax =
      maxPurchaseQuantity && maxPurchaseQuantity < MORE_SELECT_AMOUNT
        ? maxPurchaseQuantity
        : MORE_SELECT_AMOUNT
    return range(0, rangeMax + 1).map(amount => {
      return (
        <option key={amount} value={String(amount)}>
          {amount === MORE_SELECT_AMOUNT ? 'Más' : amount}
        </option>
      )
    })
  }

  renderSelect() {
    const {amount} = this.props.item
    if (amount && amount >= MORE_SELECT_AMOUNT) {
      return (
        <input
          type="text"
          value={isString(this.state.inputState) ? this.state.inputState : String(amount)}
          onChange={event => this.setState({inputState: event.target.value})}
          className={styles.biggerInput}
          onBlur={this.onChange}
        />
      )
    }
    return (
      <div className={styles.container}>
        <select className={styles.select} onChange={this.onChange} value={String(amount)}>
          {this.renderOptions()}
        </select>
      </div>
    )
  }

  renderValue() {
    const {amount} = this.props.item
    const {amountClassname} = this.props

    if (amountClassname) {
      return <div className={amountClassname}>{amount}</div>
    }

    return <div>{amount}</div>
  }

  render() {
    if (this.props.readOnly) {
      return this.renderValue()
    } else {
      return this.renderSelect()
    }
  }
}
